import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'page-500',
    template: `
    <div class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto" cdkScrollable>

    <!-- Main -->
    <div class="flex-auto">
    <div class="w-full flex items-center justify-center h-full min-h-fit">
        <div class="text-center">
            <img src="assets/images/500.svg" class="object-contain max-w-[230px] max-h-[230px]" alt="">
            <h1 class="text-center text-[90px] font-semibold text-[#0B0D13] leading-[110px] mt-4">500</h1>
            <p class="font-medium text-[22px] leading-[23px] text-[#7D7F86] text-center">{{errorMsg}}</p>
            <a  class="base_btn primary_btn mt-15" [routerLink]="isCustomer ? '/' :'/dashboard'">Back to {{backTo}}</a>
        </div>
    </div>
</div>
</div>

  `,
    styles: [],
    host: { class: 'w-full h-full' }
})
export class Error500Component {
    errorMsg: any = "Internal Server Error"
    backTo: any = "Dashboard";
    isCustomer: boolean = true;
  constructor(private _matDialog: MatDialog) {
      this._matDialog.closeAll()
        if (localStorage.getItem("currentUser")) {
          let user = JSON.parse(localStorage.getItem("currentUser"));
          if (user.roles[0].name.toLowerCase() != "customer") {
            this.backTo = "Dashboard";
            this.isCustomer = false;
          } else {
            this.backTo = "Home";
            this.isCustomer = true;
          }
        } else {
          this.backTo = "Home";
          this.isCustomer = true;
        }
      }
}
